export const FETCH_HAS_SOURCE_DOWNLOADS = 'mac/FETCH_HAS_SOURCE_DOWNLOADS';
export const FETCH_PRODUCT_SOURCE_DOWNLOAD = 'mac/FETCH_PRODUCT_SOURCE_DOWNLOAD';
export const FETCH_SOURCE_DOWNLOAD_URL = 'mac/FETCH_SOURCE_DOWNLOAD_URL';
